/**
 * @desc 广告模块
 */
const feedbackList = r => require.ensure([], () => r(require('../views/feedback/FeedbackList.vue')), 'feedbackList');

export default [
  //广告列表
  {
    name: 'feedbackList',
    path: '/feedbackList',
    component: feedbackList,
    meta: { title: '意见反馈' },
  },
]